
<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb">
          <li><a routerLink="/products/catalogs">Catalogs</a></li>
          <li>{{productObj && productObj.id ? 'Edit' : 'New' }}</li>
        </ul>
      </div>
    </div>
    <div class="flex-content" *ngIf="productObj">
      <form class="col-xs-12 p-4" #productForm="ngForm">
        <div class="col-xs-6">
          <div class="col-xs-12" *appHideField="'titleLanguageString'">
            <label class="col-xs-8 mt-0">Title</label>
            <div class="col-xs-12">
              <language-string-selection [parseObj]="productObj" name="titleLanguageString" [required]="true" [tags]="['product_title']"></language-string-selection>
            </div>
          </div>
        </div>
        <div class="col-xs-6" *appHideField="'alternateNames'">
          <label class="col-xs-6 mt-0">Alternate Names</label>
          <div class="col-xs-12 p-0 pb-2">
            <div class="badge m-2 ml-0" *ngFor="let name of alternateNames; let i = index;">
              <span class="pr-2">{{name}}</span>
              <i class="fa fa-trash-o pointer" (click)="removeAlternateName(i)"></i>
            </div>
          </div>
          <div class="col-xs-8">
            <input type="text" class="form-control" placeholder="Enter alternate name" [(ngModel)]="alternateNameInput" name="alternateNameInput"/>
          </div>
          <div class="col-xs-3 ml-2">
            <button type="button" class="btn btn-primary" (click)="addAlternateName()">Add</button>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6" *appHideField="'prescriptionRequired'">
            <label class="col-xs-6">Prescription Required</label>
            <input-checkbox [parseObj]="productObj" name="prescriptionRequired"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'isCommonAddon'">
            <label class="col-xs-6">Common Addon</label>
            <input-checkbox [parseObj]="productObj" name="isCommonAddon"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'isTablet'">
            <label class="col-xs-6">Tablet</label>
            <input-checkbox [parseObj]="productObj" name="isTablet"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'isAntibiotic'">
            <label class="col-xs-6">Antibiotic</label>
            <input-checkbox [parseObj]="productObj" name="isAntibiotic"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'isAntiFungal'">
            <label class="col-xs-6">AntiFungal</label>
            <input-checkbox [parseObj]="productObj" name="isAntiFungal"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'isRepair'">
            <label class="col-xs-6">Repair</label>
            <input-checkbox [parseObj]="productObj" name="isRepair"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'requiresDermatApproval'">
            <label class="col-xs-6">Requires Dermat Approval</label>
            <input-checkbox [parseObj]="productObj" name="requiresDermatApproval"></input-checkbox>
          </div>
          <div class="col-xs-6" *appHideField="'isDermatApprovalNeededInProductOrder'">
            <label class="col-xs-6">Requires Dermat Approval For Product Order</label>
            <input-checkbox [parseObj]="productObj" name="isDermatApprovalNeededInProductOrder"></input-checkbox>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6 flex items-center" *ngIf="productObj.id">
            <label class="col-xs-6">Is Main Product</label>
            <label class="i-switch i-switch-sm bg-success">
              <input type="checkbox" [(ngModel)]="isMainProduct" name="isMainProduct" (ngModelChange)="onMainProductToggleChange($event)"/><i></i>
            </label>
          </div>
          <div *ngIf="!productObj.id || !isMainProduct" [class.col-xs-6]="productObj.id" [class.pl-4]="productObj.id" [class.col-xs-4]="!productObj.id">
            <label class="col-xs-12 p-0">Main Product{{ !productObj.id ? ' (optional)' : '' }}</label>
            <div class="col-xs-12 p-0 pb-2" *ngIf="productObj.get('mainProduct') && productObj.get('mainProduct').id !== productObj.id">
              <div class="badge m-2 ml-0">
                <span class="pr-2">{{productObj.get('mainProduct').get('title')}}</span>
                <i class="fa fa-trash-o pointer" (click)="removeMainProduct()"></i>
              </div>
            </div>
            <input class="form-control" type="text" placeholder="Type Product Name..." matInput="matInput" name="add_main_product" autocomplete="off" [formControl]="autoCompleteMainProductController" [matAutocomplete]="mainProductAuto"/>
            <mat-autocomplete class="search-bar-xs" #mainProductAuto="matAutocomplete">
              <mat-option *ngFor="let option of mainProductOptions | async" [value]="option.name" (onSelectionChange)="autoCompleteOnMainProductSelect(option)">{{option.name}}</mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="col-xs-12 flex space-between" *appHideField="'safteyProfile'">
          <div class="col-xs-6">
            <label>Saftey Profile</label>
            <input-select [parseObj]="productObj" name="safteyProfile" [options]="safteyProfileOptions" (onValueChanged)="addPregAndBfTags($event)"></input-select>
          </div>
          <div class="col-xs-6 ml-4">
            <label>Requires Approval</label>
            <input-select [parseObj]="productObj" name="requiresApproval" [options]="requiresApprovalOptions"></input-select>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'inventoryStatus'">
          <div class="col-xs-6">
            <label>Inventory Status</label>
            <input-select [parseObj]="productObj" name="inventoryStatus" [options]="inventoryStatus" [disabled]="isInventoryStatusDiscontinued" required="true"></input-select>
          </div>
          <div class="col-xs-6 pl-4" *ngIf="productObj.get('inventoryStatus') === apiClientConstant.Catalog.InventoryStatus.DISCONTINUED">
            <label>Alternative Product</label>
            <div class="col-xs-12 p-0 pb-2" *ngIf="productObj.get('alternateProduct')">
              <div class="badge m-2 ml-0"><span class="pr-2">{{productObj.get('alternateProduct').get('title')}}</span><i class="fa fa-trash-o pointer" (click)="removeAlternateProduct()"></i></div>
            </div>
            <input class="form-control" type="text" placeholder="Type Product Name..." matInput="matInput" name="add_product" autocomplete="off" [formControl]="autoCompleteProductController" [matAutocomplete]="productAuto"/>
            <mat-autocomplete class="search-bar-xs" #productAuto="matAutocomplete">
              <mat-option *ngFor="let option of productOptions | async" [value]="option.name" (onSelectionChange)="autoCompleteOnProductSelect(option)">{{option.name}}</mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="col-xs-12 flex space-between">
          <div class="col-xs-6" *appHideField="'reorderType'">
            <label class="col-xs-4">Reorder type</label>
            <input-select [parseObj]="productObj" name="reorderType" [options]="paymentOptions" [required]="true"></input-select>
          </div>
          <div class="col-xs-6 ml-4">
            <label class="col-xs-4">Prescription Validity In Days</label>
            <input-text [parseObj]="productObj" type="number" name="prescriptionValidityInDays" [required]="true"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6" *appHideField="'trackingCategoryType'">
            <label class="col-xs-4">Tracking Category</label>
            <div class="col-xs-12">
              <input-select [parseObj]="productObj" name="trackingCategoryType" [options]="trackingCategory"></input-select>
            </div>
          </div>
          <div class="col-xs-6 pl-4" *appHideField="'searchTerms'">
            <label class="col-xs-4">Search Terms</label>
            <input-text [parseObj]="productObj" name="searchTerms"></input-text>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'ranking'">
          <div class="col-xs-4">
            <label>Ranking (Recommended product section ranking)</label>
            <input-text [parseObj]="productObj" name="ranking" type="number"></input-text>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'productUnboxedImage'">
          <label class="col-xs-4">Product Unboxed Image</label>
          <div class="col-xs-12 m-r-xs flex">
            <input-image-upload [parseObj]="productObj" name="productUnboxedImage" [required]="false" [accept]="'image/png'" [constraints]="{ size: 150000, aspectRadio: [1, 2] }"></input-image-upload>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6" *appHideField="'rebrandedImageWithBackground'">
            <label class="col-xs-4">Rebranded Unboxed Product Image with Background</label>
            <div class="col-xs-12 m-r-xs flex">
              <input-image-upload [parseObj]="productObj" name="rebrandedImageWithBackground" [required]="false" [accept]="'image/png, image/jpg, image/jpeg'" [constraints]="{ size: 150000, aspectRadio: [1, 1.25, 2] }"></input-image-upload>
            </div>
          </div>
          <div class="col-xs-6" *appHideField="'rebrandedImageWithoutBackground'">
            <label class="col-xs-4">Rebranded Unboxed Product Image Without Background</label>
            <div class="col-xs-12 m-r-xs flex">
              <input-image-upload [parseObj]="productObj" name="rebrandedImageWithoutBackground" [required]="false" [accept]="'image/png'" [constraints]="{ size: 150000 }"></input-image-upload>
            </div>
          </div>
        </div>
        <div class="col-xs-12 bdr-2-black p-2" *appHideField="'extraImages'">
          <div class="col-xs-12">
            <label>Extra images for slider</label><i class="fa fa-plus-square-o pointer m-l-xs m-r-xs" (click)="addExtraImages()"></i>
          </div>
          <ng-container *ngFor="let isVisible of extraImages; index as i">
            <div class="col-xs-4 flex" *ngIf="isVisible">
              <input-image-upload [parseObj]="productObj" [name]="'extraImages_'+i" [required]="false" [accept]="'image/png, video/mp4'" [constraints]="{ size: 1500000 }"></input-image-upload><i class="fa fa-minus-square-o pointer m-l-xs m-r-xs" (click)="removeExtraImages(i)"></i>
            </div>
          </ng-container>
        </div>
        <extra-images-with-tags
          *appHideField="'extraImagesWithTags'"
          [value]="productObj.get('extraImagesWithTags') || []">
        </extra-images-with-tags>
        <div class="col-xs-12" *appHideField="'descriptionLanguageString'">
          <label class="col-xs-4">Product Description</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="descriptionLanguageString" [required]="true" [tags]="['productdescription']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'featureListLanguageString'">
          <label class="col-xs-4">Product Features</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="featureListLanguageString" [tags]="['productfeature']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'ingredientListLanguageString'">
          <label class="col-xs-4">Product Ingredients</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="ingredientListLanguageString" [tags]="['productingredient']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'instructionListLanguageString'">
          <label class="col-xs-4">How to use</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="instructionListLanguageString" [tags]="['productinstruction']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-4" *appHideField="'vendorName'">
            <label>Vendor Name</label>
            <input-text [parseObj]="productObj" name="vendorName"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-4" *appHideField="'keyActive'">
            <label class="col-xs-12">Ingredient key Active</label>
            <textarea class="w100" [(ngModel)]="keyActive" name="keyActive"></textarea>
          </div>
          <div class="col-xs-4 pl-4" *appHideField="'supportingActive'">
            <label class="col-xs-12">Ingredient supporting Active</label>
            <textarea class="w100" [(ngModel)]="supportingActive" name="supportingActive"></textarea>
          </div>
          <div class="col-xs-4 pl-4" *appHideField="'baseIngredients'">
            <label class="col-xs-12">Ingredient Base ingredients</label>
            <textarea class="w100" [(ngModel)]="baseIngredients" name="baseIngredients"></textarea>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'ingredientsLanguageString'">
          <label class="col-xs-12">Ingredients</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="ingredientsLanguageString" [tags]="['ingredients']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'productHighlights'">
          <div class="flex items-center">
            <label>Product Highlights</label>
            <div><i data-testid="add-highlight" class="fa fa-plus-square-o ml-2 pointer" (click)="addProductHighlights()"></i></div>
          </div>
          <p class="alert-danger" style="width: max-content;">Note: Character limit = 55 ; Add only English & Hindi</p>
          <div *ngFor="let highlight of productHighlights; let i = index;">
            <div class="col-xs-12 flex items-center mb-4">
              <div class="flex">
                <img [src]="highlight.get('image')" width="50" height="50" alt="highlight_img"/>
                <i class="fa fa-pencil-square-o pull-right pointer" style="margin-bottom: auto;" (click)="editProductHighlights(highlight, i)"></i>
              </div>
              <div class="col-xs-12 flex items-center" style="margin-left: 50px;">
                <language-string-selection [parseObj]="highlight" name="descriptionLanguageString" [prefix]="'highlight_' + i" [tags]="['product-highlight-description']" (languageStringObjChange)="onHighlightDescriptionChange(highlight, $event)"></language-string-selection>
              </div>
              <i class="fa fa-trash-o pointer pl-2 pull-right" style="margin-bottom: auto;" (click)="removeProductHighlights(i)"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 flex" *appHideField="'heroIngredientsLanguageStrings'">
          <language-string-multiple-selection class="col-xs-7" [parseObj]="productObj" name="heroIngredientsLanguageStrings" title="Hero Ingredients" [required]="true" [tags]="['hero-ingredient-title']" [allowDuplicates]="false" (onSelection)="onHeroIngredientsChange($event)"></language-string-multiple-selection>
          <div><i class="fa fa-plus-square-o ml-2 pointer" (click)="addHeroIngredients()"></i></div>
        </div>
        <div class="col-xs-6" *appHideField="'quantity'">
          <label class="col-xs-12">Net Weight/Volume</label>
          <div class="col-xs-4 pr-4">
            <input-text [parseObj]="productObj" required="required" name="quantity" placeholder=""></input-text>
          </div>
          <div class="col-xs-2">
            <input-select [parseObj]="productObj" name="quantityUnit" [options]="quantityUnits" required="required"></input-select>
          </div>
        </div>
        <div class="col-xs-6" *appHideField="'category'">
          <label class="col-xs-12">Category</label>
          <div class="col-xs-2">
            <input-select [parseObj]="productObj" name="category" [options]="categories" required="required"></input-select>
          </div>
        </div>
        <div class="col-xs-6" *appHideField="'subCategory'">
          <label class="col-xs-12">Sub Category</label>
          <div class="col-xs-2">
            <input-select [parseObj]="productObj" name="subCategory" [options]="subCategories" required="required"></input-select>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'margId'">
          <div class="col-xs-3 pr-4">
            <label class="col-xs-4">Marg ID</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" required="required" name="margId" placeholder=""></input-text>
            </div>
          </div>
          <div class="col-xs-6 pr-4" *appHideField="'margName'">
            <label class="col-xs-12">Marg Name</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" name="margName" placeholder=""></input-text>
            </div>
          </div>
          <div class="col-xs-3 pr-4" *appHideField="'margUnit'">
            <label class="col-xs-12">Marg Unit</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" name="margUnit" placeholder="" type="number"></input-text>
            </div>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'mrp'">
          <div class="col-xs-3 pr-4">
            <label class="col-xs-12">MRP</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" name="mrp" placeholder="MRP" type="number" min="0" required="required" (onValueChange)="ui.maxSellingPrice = $event"></input-text>
            </div>
          </div>
          <div class="col-xs-3 pr-4" *appHideField="'price'">
            <label class="col-xs-12">Selling price (inc. GST)</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" name="price" placeholder="Selling Price" type="number" [max]="ui.maxSellingPrice" required="required" (onValueChange)="ui.maxEffectivePrice = $event; updateTaxDetails()"></input-text>
            </div>
          </div>
          <div class="col-xs-3 pr-4" *appHideField="'effectiveCostPrice'">
            <label class="col-xs-12">Effective Cost Price</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" name="effectiveCostPrice" placeholder="Effective Cost Price" type="number" [min]="ui.minEffectivePrice" required="required"></input-text>
            </div>
          </div>
          <div class="col-xs-3 pr-4" *appHideField="'recommendedReorderDays'">
            <label class="col-xs-12">Recommended Reorder Days</label>
            <div class="col-xs-12">
              <input-text [parseObj]="productObj" name="recommendedReorderDays" placeholder="Recommended Reorder Days" type="number"></input-text>
            </div>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'purposeLanguageString'">
          <label class="col-xs-4">Purpose</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="purposeLanguageString" [required]="true" [tags]="['purpose']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12" *appHideField="'purposeDescriptionLanguageString'">
          <label class="col-xs-4">Purpose Description</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="productObj" name="purposeDescriptionLanguageString" [required]="true" [tags]="['purposedescription']"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-12 mt-4 flex">
          <div class="col-xs-4 flex" *appHideField="'gstn'">
            <label class="col-xs-2 m-0">GSTN</label>
            <div class="col-xs-9">
              <input-select [parseObj]="productObj" name="gstn" [options]="gstnOptions" [required]="true" [disabled]="productObj.get('gstn')"></input-select>
            </div>
          </div>
          <div class="col-xs-3 flex" *appHideField="'gstSlab'">
            <label class="col-xs-3 m-0">GST%</label>
            <div class="col-xs-9">
              <select name="GST" [(ngModel)]="gstSelectedSlab" (change)="updateTaxDetails()" required="required">
                <option [value]="undefined" disabled="disabled">Select Slab</option>
                <option *ngFor="let slab of GST_SLABS" value="{{slab}}">{{slab}}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-2 flex" *appHideField="'cgst'">
            <label class="col-xs-3 m-0">CGST:</label>
            <div class="col-xs-9">{{ui.cgst | number:'.1-2'}}</div>
          </div>
          <div class="col-xs-2 flex" *appHideField="'sgst'">
            <label class="col-xs-3 m-0">SGST:</label>
            <div class="col-xs-9">{{ui.sgst | number:'.1-2'}}</div>
          </div>
        </div>
        <div class="col-xs-12 mt-4" *appHideField="'searchKeywords'">
          <language-string-multiple-selection class="col-xs-7" [parseObj]="productObj" name="searchKeywordLanguageStringArray" title="Search Keywords" [tags]="['search_keyword']" [allowDuplicates]="false"></language-string-multiple-selection>
        </div>
        <div class="col-xs-12 articleMargin" *appHideField="'articleImagesLanguageString'">
          <label class="col-xs-12"></label>
          <div class="col-xs-12">
            <language-string-multiple-selection-with-tag title="Upload Article Image" [parseObj]="articleObj?.get('params')" name="articleImagesLanguageString" [required]="true" [tags]="['article_image']" [showUploadButton]="true"></language-string-multiple-selection-with-tag>
          </div>
        </div>
        <div class="col-xs-12 articleMargin" *appHideField="'articleImagesLanguageStringWithTag'" style="background: #eee; margin: 0; padding-bottom: 20px;">
          <label class="col-xs-12"></label>
          <div class="col-xs-12">
            <language-string-multiple-selection-with-tag title="Upload Article Image with Tag" [parseObj]="articleWithTagObj?.get('params')" name="articleImagesLanguageString" [required]="true" [tags]="['article_image']" [showUploadButton]="true"></language-string-multiple-selection-with-tag>
          </div>
          <label class="col-xs-12 mb-0" *ngIf="articleWithTagObj?.get('params')?.articleImagesLanguageString?.length">User tag for article</label>
          <label class="col-xs-12" *ngIf="articleWithTagObj?.get('params')?.articleImagesLanguageString?.length">
            <select name="userTagForArticle" [(ngModel)]="userTagForArticle" required="required">
              <option *ngFor="let tag of userTagList" [value]="tag">{{tag}}</option>
            </select>
          </label>
        </div>
        <div class="col-xs-12 mt-4">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header  style="background: #eee;">
                <mat-expansion-panel-title class="bold uppercase fontR">Maybe Needed?</mat-expansion-panel-title>
              </mat-expansion-panel-header>
              <div class="col-xs-12 mt-4" *appHideField="'tags'">
                <language-string-tag-selection [parseObj]="productObj" name="tags"></language-string-tag-selection>
              </div>
              <div *appHideField="'conditions'">
                <div class="col-xs-12" *appHideField="'conditions'">
                  <label class="col-xs-4">Conditions</label>
                </div>
                <div class="col-xs-12">
                  <question-condition [conditions]="productObj.get('conditions')"></question-condition>
                </div>
              </div>
              <div class="col-xs-4" *appHideField="'marketEquivalentName'">
                <label>Market Equivalent Name</label>
                <input-text [parseObj]="productObj" name="marketEquivalentName"></input-text>
              </div>
              <div class="col-xs-4 pl-2" *appHideField="'grossWeight'">
                <label class="col-xs-12">Gross Weight(in gms)</label>
                <div class="col-xs-12">
                  <input-text [parseObj]="productObj" name="grossWeight" placeholder="Weight in grams"></input-text>
                </div>
              </div>
              <div class="col-xs-12">
                <div class="col-xs-6 pr-4" *appHideField="'videoLinkPaid'">
                  <label class="col-xs-4">Video Link - Paid User</label>
                  <div class="col-xs-12">
                    <input-text [parseObj]="productObj" name="videoLinkPaid" placeholder="link_paid"></input-text>
                  </div>
                </div>
                <div class="col-xs-6" *appHideField="'videoLinkUnpaid'">
                  <label class="col-xs-5">Video Link - Unpaid User</label>
                  <div class="col-xs-12">
                    <input-text [parseObj]="productObj" name="videoLinkUnpaid" placeholder="link_unpaid"></input-text>
                  </div>
                </div>
              </div>
              <div class="col-xs-3 pr-4" *appHideField="'externalEffectiveCostPrice'">
                <label class="col-xs-12">Private label cost</label>
                <div class="col-xs-12">
                  <input-text [parseObj]="productObj" name="externalEffectiveCostPrice" placeholder="External effective Cost Price" type="number"></input-text>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'offerAmount'">
                <div class="col-xs-3 pr-4">
                  <label class="col-xs-12">Offer Amount</label>
                  <div class="col-xs-12">
                    <input-text [parseObj]="productObj" name="offerAmount" placeholder="Offer Amount" type="number"></input-text>
                  </div>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'restrictions'">
                <label class="col-xs-4">Restrictions</label>
                <div class="col-xs-12 pl-0">
                  <language-string-multiple-selection-with-tag [parseObj]="productObj" name="restrictions"></language-string-multiple-selection-with-tag>
                </div>
              </div>
              <div class="col-xs-12 mb-3" *appHideField="'shopTags'">
                <label class="col-xs-12">Shop Tags</label>
                <div class="col-xs-7">
                  <input-multi-select [parseObj]="productObj" name="shopTags" [options]="shopTags"></input-multi-select>
                </div>
              </div>
              <div class="col-xs-12 mb-3" *appHideField="'excludeBoostProductsTags'">
                <label class="col-xs-12">Exclude Boost Your Regimen Tags</label>
                <div class="col-xs-7">
                  <input-multi-select [parseObj]="productObj" name="excludeBoostProductsTags" [options]="excludeBoostProductsTags"></input-multi-select>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'sideEffects'">
                <label class="col-xs-4">Side Effects</label>
                <div class="col-xs-12 pl-0">
                  <language-string-multiple-selection-with-tag [parseObj]="productObj" name="sideEffects"></language-string-multiple-selection-with-tag>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'indicationRestrictions'">
                <label class="col-xs-4">Indication Restrictions (Not visible to user)</label>
                <div class="col-xs-12 pl-0">
                  <language-string-multiple-selection-with-tag [parseObj]="productObj" name="indicationRestrictions"></language-string-multiple-selection-with-tag>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'key_features'">
                <label class="col-xs-4">Key Features</label>
                <div class="col-xs-12 pl-0">
                  <language-string-multiple-selection-with-tag [parseObj]="productObj" name="key_features" [required]="true" [tags]="['key_features']"></language-string-multiple-selection-with-tag>
                </div>
              </div>
              <div class="col-xs-12 flex">
                <div class="col-xs-6 flex" *appHideField="'articleTitleLanguageString'">
                  <label class="col-xs-12 mt-0">Internal title for article
                    <div class="col-xs-12">
                      <language-string-selection [parseObj]="articleObj" name="titleLanguageString" [tags]="['article','internal_title']" prefix="article"></language-string-selection>
                    </div>
                  </label>
                </div>
                <div class="col-xs-6 flex" *appHideField="'toolbarTitleLanguageString'">
                  <label class="col-xs-12 mt-0">Toolbar title for article
                    <div class="col-xs-12">
                      <language-string-selection [parseObj]="articleObj" name="toolbarTitleLanguageString" [tags]="['article','toolbar_title']"></language-string-selection>
                    </div>
                  </label>
                </div>
              </div>
              <div class="col-xs-12 flex mt-3" *appHideField="'boostYourRegimenTags'">
                <div class="col-xs-4">
                  <label class="col-xs-12 mt-0">Boost Your Regimen Tags</label>
                  <div class="col-xs-12">
                    <input-multi-select [parseObj]="productObj" name="boostYourRegimenTags" [options]="boostYourRegimenTags"></input-multi-select>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header  style="background: #eee;">
                <mat-expansion-panel-title class="bold uppercase fontR">Not Needed(maybe)?</mat-expansion-panel-title>
              </mat-expansion-panel-header>
              <div class="col-xs-6" *appHideField="'internalTitle'">
                <label class="col-xs-4 mt-0">Internal Title</label>
                <div class="col-xs-12">
                  <input-text [parseObj]="productObj" name="internalTitle"></input-text>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'hiddenTitleLanguageString'">
                <label class="col-xs-4">Hidden Title</label>
                <div class="col-xs-12">
                  <language-string-selection [parseObj]="productObj" name="hiddenTitleLanguageString" [tags]="['hidden_titles']"></language-string-selection>
                </div>
              </div>
              <div class="col-xs-12" *appHideField="'displayNameLanguageString'">
                <label class="col-xs-4">Display Name</label>
                <div class="col-xs-12">
                  <language-string-selection [parseObj]="productObj" name="displayNameLanguageString" [required]="false" [tags]="['display_name']"></language-string-selection>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div class="col-xs-12 mt-5">
          <button type="submit" [disabled]="!productForm.valid || disabled" (click)="saveProduct()">{{ productObj.id ? 'Update' : 'Create' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>
